import {useEffect} from 'react';
import {useRouter} from 'next/router';

import {Screen} from '#component/base';
import {withRequireUserState} from '#component/util/RequireUserState/RequireUserState';

/**
 * This page was deprecated as part of the unbundling launch.
 * Customers should be redirected back into the store to modify their subscription.
 */
export const AmplifyScreen = () => {
  const router = useRouter();
  useEffect(() => {
    router.replace('/profile?tab=manage');
  }, [router]);

  return <Screen loading={true} pageName="Amplify Upsell App" withDefaultSizing={false}></Screen>;
};

export const Amplify = withRequireUserState(AmplifyScreen, {userState: 'verified'});
